<template>
  <div id="statistics">
    <h1 class="text-center">Statistics</h1>
    <hr />
    <h3>Products</h3>
    <div class="row">
      <div class="col-sm">
        <div class="card text-center">
          <div class="card-body">
            <h5 class="card-title">Total</h5>
            <p class="card-text" style="font-size: 26px;">
              <b-spinner type="grow" label="Loading..." v-if="!statistics.product.total"></b-spinner>
              <strong v-else>{{ statistics.product.total }}</strong>
            </p>
            <b-icon icon="check-circle-fill" font-scale="2" class="text-primary"></b-icon>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card text-center">
          <div class="card-body">
            <h5 class="card-title">Views</h5>
            <p class="card-text" style="font-size: 26px;">
              <b-spinner type="grow" label="Loading..." v-if="!statistics.product.clicks"></b-spinner>
              <strong v-else>{{ statistics.product.clicks }}</strong>
            </p>
            <b-icon icon="heart-fill" font-scale="2" class="text-primary"></b-icon>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card text-center">
          <div class="card-body">
            <h5 class="card-title">Clicks</h5>
            <p class="card-text" style="font-size: 26px;">
              <b-spinner type="grow" label="Loading..." v-if="!statistics.product.views"></b-spinner>
              <strong v-else>{{ statistics.product.views }}</strong>
            </p>
            <b-icon icon="x-diamond-fill" font-scale="2" class="text-primary"></b-icon>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm">
        <div class="card text-center">
          <div class="card-body">
            <h5 class="card-title">Total Suppliers</h5>
            <p class="card-text" style="font-size: 26px;">
              <b-spinner type="grow" label="Loading..." v-if="!statistics.supplier.total"></b-spinner>
              <strong v-else>{{ statistics.supplier.total }}</strong>
            </p>
            <b-icon icon="people-fill" font-scale="2" class="text-primary"></b-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStatistics } from "@/api/services/statistics";
export default {
  data() {
    return {
      statistics: {
        product: {
          total: 0,
          clicks: 0,
          views: 0,
        },
        supplier: {
          total: 0,
          clicks: 0,
          views: 0,
        },
      },
    };
  },
  mounted() {
    this.fetchStatistics();
  },
  methods: {
    async fetchStatistics() {
      try {
        let { data } = await getStatistics();
        this.statistics = data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  color: #fff !important;
}
</style>